/* gtr-cookie-consent-fix.js
   Cookie-Auswahl und Ćbernahme zwischen den GTR-Shops.
   Dieses Asset ist die einzige Steuerung fĆ¼r den Cookie-Schritt.
*/
(() => {
  if (window.gtrCookieConsentFixBound || window.Shopify?.designMode) return;
  window.gtrCookieConsentFixBound = true;

  const STORAGE_KEY = 'gtr.cookie_consent.v2';
  const COOKIE_NAME = 'gtr_cookie_consent_v2';
  const TRANSFER_PARAM = '_gtr_consent';
  const YEAR_SECONDS = 60 * 60 * 24 * 365;
  const API_TIMEOUT_MS = 4000;
  const CATEGORIES = ['preferences', 'analytics', 'marketing'];
  const HOSTS = ['gtrseeds.de', 'www.gtrseeds.de', 'gtrseeds.eu', 'www.gtrseeds.eu'];
  let initialized = false;
  let record = null;
  let apiPromise = null;
  let sendPromise = null;
  let acknowledgedId = null;
  let manualPreferences = false;
  let manualPanel = false;
  let manualDraft = null;
  let choicePrompted = false;
  let lastAgeEvent = false;
  const inFlight = new Set();

  const safe = (fn, fallback) => {
    try { return fn(); } catch (_) { return fallback; }
  };
  const family = host => host.replace(/^www\./, '');
  const cookieDomain = () => HOSTS.includes(location.hostname) ? '.' + family(location.hostname) : '';
  const readCookie = name => safe(() => {
    const prefix = name + '=';
    const value = document.cookie.split(';').map(part => part.trim()).find(part => part.startsWith(prefix));
    return value ? decodeURIComponent(value.slice(prefix.length)) : null;
  }, null);
  const writeCookie = value => safe(() => {
    const secure = location.protocol === 'https:' ? '; Secure' : '';
    const domain = cookieDomain();
    const text = COOKIE_NAME + '=' + encodeURIComponent(value) + '; Max-Age=' + YEAR_SECONDS +
      '; Path=/; SameSite=Lax' + secure;
    if (domain) document.cookie = text + '; Domain=' + domain;
    document.cookie = text;
  });

  const valid = value => value && value.version === 2 && typeof value.id === 'string' &&
    Number.isFinite(value.created) && value.created <= Date.now() &&
    Date.now() - value.created < YEAR_SECONDS * 1000 &&
    typeof value.pending === 'boolean' && CATEGORIES.every(key => typeof value[key] === 'boolean');
  const readRecord = () => {
    if (valid(record)) return record;
    const stored = safe(() => localStorage.getItem(STORAGE_KEY), null);
    const cookieValues = safe(() => document.cookie.split(';').map(part => part.trim())
      .filter(part => part.startsWith(COOKIE_NAME + '='))
      .map(part => safe(() => decodeURIComponent(part.slice(COOKIE_NAME.length + 1)), null)), []);
    // A corrupt local entry must not hide a valid cookie. If host and domain
    // cookies differ, use the newest actual decision instead of the first one.
    const choices = [stored, ...cookieValues].map(value => safe(() => JSON.parse(value), null))
      .filter(valid).sort((a, b) => b.created - a.created);
    record = choices[0] || null;
    return record;
  };
  const persist = value => {
    record = value;
    const text = JSON.stringify(value);
    safe(() => localStorage.setItem(STORAGE_KEY, text));
    writeCookie(text);
    document.documentElement.classList.add('gtr-cookie-consent-known');
  };
  const remember = (choice, pending = true, created = Date.now()) => {
    const value = {
      version: 2,
      id: Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 9),
      created,
      pending,
      preferences: choice.preferences === true,
      analytics: choice.analytics === true,
      marketing: choice.marketing === true
    };
    persist(value);
    return value;
  };
  const ageVerified = () =>
    lastAgeEvent || document.getElementById('gtr-agegate')?.getAttribute('data-gtr-age-verified') === 'true' ||
    safe(() => localStorage.getItem('gtr_age_verified') === '1', false) || readCookie('gtr_age_verified') === '1';
  const getGate = () => document.getElementById('gtr-agegate');
  const apiNow = () => {
    const api = window.Shopify?.customerPrivacy;
    return api && typeof api.setTrackingConsent === 'function' ? api : null;
  };
  const apiChoice = api => {
    const choice = safe(() => api?.currentVisitorConsent?.(), null);
    if (!choice || !CATEGORIES.every(key => choice[key] === 'yes' || choice[key] === 'no')) return null;
    return Object.fromEntries(CATEGORIES.map(key => [key, choice[key] === 'yes']));
  };

  const loadApi = () => {
    const available = apiNow();
    if (available) return Promise.resolve(available);
    if (apiPromise) return apiPromise;
    const pending = new Promise(resolve => {
      let ended = false;
      let timer;
      let started = false;
      const finish = api => {
        if (ended) return;
        ended = true;
        clearTimeout(deadline);
        clearTimeout(timer);
        resolve(api);
      };
      const deadline = setTimeout(() => finish(apiNow()), API_TIMEOUT_MS);
      const attempt = () => {
        if (ended) return;
        const api = apiNow();
        if (api) return finish(api);
        if (!started && typeof window.Shopify?.loadFeatures === 'function') {
          started = true;
          try {
            window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
              if (error) return finish(null);
              if (apiNow()) finish(apiNow());
            });
          } catch (_) { return finish(null); }
        }
        timer = setTimeout(attempt, 250);
      };
      attempt();
    });
    apiPromise = pending;
    pending.then(() => { if (apiPromise === pending) apiPromise = null; });
    return pending;
  };

  const hideLegacy = () => {
    const gate = getGate();
    if (gate?.querySelector('[data-gtr-step="privacy"]')) {
      // The old theme banner duplicates the current settings input IDs.
      // Remove only its three known roots; the age gate remains in place.
      ['gtr-cookie', 'gtr-cookie-overlay', 'gtr-cookie-modal'].forEach(id => {
        document.getElementById(id)?.remove();
      });
    } else {
      ['gtr-cookie', 'gtr-cookie-overlay', 'gtr-cookie-modal'].forEach(id => {
        const element = document.getElementById(id);
        if (!element) return;
        element.classList.remove('is-open');
        element.style.display = 'none';
        element.setAttribute('aria-hidden', 'true');
      });
    }
  };

  const closeCookieUi = () => {
    hideLegacy();
    const gate = getGate();
    if (!gate || !ageVerified()) return;
    const privacy = gate.querySelector('[data-gtr-step="privacy"]');
    if (privacy && !privacy.hidden) privacy.hidden = true;
    gate.classList.remove('gtr-cookie-step-active');
    // The age script may still be waiting on Shopify after emitting its
    // confirmed-age event. Only that confirmed state may close the gate.
    if (gate.classList.contains('is-open')) gate.classList.remove('is-open');
    if (gate.getAttribute('aria-hidden') !== 'true') gate.setAttribute('aria-hidden', 'true');
    if (document.documentElement.classList.contains('gtr-agegate-open')) {
      document.documentElement.classList.remove('gtr-agegate-open');
    }
    const settings = gate.querySelector('#gtr-consent-settings');
    if (settings && !settings.hidden) settings.hidden = true;
    const toggle = gate.querySelector('[data-consent-action="settings"]');
    if (toggle && toggle.getAttribute('aria-expanded') !== 'false') toggle.setAttribute('aria-expanded', 'false');
    const error = gate.querySelector('#gtr-consent-error');
    if (error && !error.hidden) error.hidden = true;
  };

  const syncInputs = (root, choice) => {
    if (!root || !choice) return;
    CATEGORIES.forEach(key => {
      const input = root.querySelector('[data-consent-category="' + key + '"]') ||
        root.querySelector('#gtr-consent-' + key);
      if (input) input.checked = choice[key] === true;
    });
  };

  const showPrivacy = (settings = false) => {
    if (!ageVerified()) return;
    const gate = getGate();
    if (gate) {
      const age = gate.querySelector('[data-gtr-step="age"]');
      const privacy = gate.querySelector('[data-gtr-step="privacy"]');
      if (!privacy) return;
      if (age) age.hidden = true;
      privacy.hidden = false;
      gate.classList.add('is-open', 'gtr-cookie-step-active');
      gate.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('gtr-agegate-open');
      const panel = gate.querySelector('#gtr-consent-settings');
      if (panel) panel.hidden = !settings;
      gate.querySelector('[data-consent-action="settings"]')?.setAttribute('aria-expanded', settings ? 'true' : 'false');
      syncInputs(gate, readRecord() || apiChoice(apiNow()));
    } else {
      const modal = document.getElementById('gtr-cookie-modal');
      if (settings && modal) {
        modal.style.display = 'block';
        modal.setAttribute('aria-hidden', 'false');
        const overlay = document.getElementById('gtr-cookie-overlay');
        if (overlay) overlay.style.display = 'block';
        syncInputs(modal, readRecord() || apiChoice(apiNow()));
      } else {
        const banner = document.getElementById('gtr-cookie');
        if (banner) {
          banner.style.display = 'grid';
          banner.classList.add('is-open');
          banner.setAttribute('aria-hidden', 'false');
        }
      }
    }
  };

  const send = (api, value) => new Promise(resolve => {
    let ended = false;
    const finish = success => {
      if (ended) return;
      ended = true;
      clearTimeout(deadline);
      resolve(success);
    };
    const deadline = setTimeout(() => finish(false), API_TIMEOUT_MS);
    try {
      inFlight.add(value.id);
      api.setTrackingConsent(Object.fromEntries(CATEGORIES.map(key => [key, value[key]])), response => {
        inFlight.delete(value.id);
        const success = !(response && response.error);
        if (success && readRecord()?.id === value.id) {
          acknowledgedId = value.id;
          persist({ ...value, pending: false });
          document.dispatchEvent(new CustomEvent('gtr:privacy-updated', {
            detail: Object.fromEntries(CATEGORIES.map(key => [key, value[key]]))
          }));
        } else if (success) {
          const latest = readRecord();
          const actual = apiChoice(api);
          if (latest && !latest.pending && latest.created >= value.created &&
            (!actual || CATEGORIES.some(key => actual[key] !== latest[key]))) {
            // A timed-out earlier request must not undo a newer opt-out.
            remember(latest, true, latest.created);
            Promise.resolve().then(flush);
          }
        }
        finish(success);
      });
    } catch (_) { inFlight.delete(value.id); finish(false); }
  });

  const flush = () => {
    if (sendPromise) return sendPromise;
    const value = readRecord();
    if (!value?.pending) return Promise.resolve(false);
    const task = (async () => {
      const api = await loadApi();
      if (!api || readRecord()?.id !== value.id) return false;
      return send(api, value);
    })();
    sendPromise = task;
    task.then(() => {
      if (sendPromise === task) sendPromise = null;
      const latest = readRecord();
      if (latest?.pending && latest.id !== value.id) flush();
    });
    return task;
  };

  const save = choice => {
    remember(choice);
    manualPreferences = false;
    manualDraft = null;
    closeCookieUi();
    // The actual choice stays queued if Shopify is unavailable. The browser
    // remains usable; no local code grants tracking or fabricates API success.
    flush();
  };

  const captureCurrentChoice = () => {
    const stored = readRecord();
    if (stored) return stored;
    // Import an existing native decision before opening our first prompt.
    // A late API/default state must never overwrite a real saved choice or
    // silently dismiss a prompt that the visitor is already using.
    if (choicePrompted) return null;
    const actual = apiChoice(apiNow());
    return actual ? remember(actual, false) : null;
  };

  const makeTransfer = () => {
    if (!HOSTS.includes(location.hostname)) return null;
    const value = captureCurrentChoice();
    if (!value) return null;
    // This contains only three consent choices and timestamps, no visitor ID.
    return ['2', Date.now(), value.created, family(location.hostname),
      ...CATEGORIES.map(key => value[key] ? 'y' : 'n')].join('~');
  };

  // Cart permalinks can discard unknown query parameters during their redirect.
  // A URL fragment survives an HTTP redirect and is consumed by these two assets.
  const readHandoff = url => safe(() => {
    const prefix = '#_gtr_handoff=';
    if (!url.hash.startsWith(prefix) || url.hash.length > 8192) return null;
    const data = JSON.parse(decodeURIComponent(url.hash.slice(prefix.length)));
    return data && typeof data === 'object' && typeof data.hash === 'string' &&
      (!data.hash || data.hash.startsWith('#')) && data.hash.length < 4096 ? data : null;
  }, null);

  const takeTransfer = (url, parameter, key) => {
    const handoff = readHandoff(url);
    const token = url.searchParams.get(parameter) || handoff?.[key];
    if (typeof token !== 'string' || !token) return null;
    url.searchParams.delete(parameter);
    if (handoff) {
      delete handoff[key];
      url.hash = handoff.age || handoff.consent
        ? '#_gtr_handoff=' + encodeURIComponent(JSON.stringify(handoff))
        : handoff.hash;
    }
    safe(() => history.replaceState(history.state, '', url.pathname + url.search + url.hash));
    return token;
  };

  const importTransfer = () => {
    if (!HOSTS.includes(location.hostname)) return;
    const url = new URL(location.href);
    const payload = takeTransfer(url, TRANSFER_PARAM, 'consent');
    if (!payload) return;
    const parts = payload.split('~');
    const referrer = safe(() => new URL(document.referrer), null);
    const issued = Number(parts[1]);
    const created = Number(parts[2]);
    const age = Date.now() - issued;
    if (parts.length !== 7 || parts[0] !== '2' || !Number.isFinite(issued) ||
      !Number.isFinite(created) || created > issued || Date.now() - created >= YEAR_SECONDS * 1000 ||
      age < 0 || age > 10 * 60 * 1000 || !referrer || referrer.protocol !== 'https:' ||
      !HOSTS.includes(referrer.hostname) || family(referrer.hostname) !== parts[3] ||
      !['gtrseeds.de', 'gtrseeds.eu'].includes(parts[3]) ||
      !parts.slice(4).every(value => value === 'y' || value === 'n')) return;
    // Only a recent handoff from one of this shop's own domains is accepted.
    // A pasted external URL cannot grant consent. Age verification is not imported.
    const local = readRecord();
    if (local && local.created > created) return;
    remember(Object.fromEntries(CATEGORIES.map((key, i) => [key, parts[i + 4] === 'y'])), true, created);
  };

  const decorateLink = anchor => {
    const target = safe(() => new URL(anchor.href, location.href), null);
    if (!target || target.protocol !== 'https:' || !HOSTS.includes(target.hostname) ||
      family(target.hostname) === family(location.hostname)) return;
    const payload = makeTransfer();
    if (!payload) return;
    target.searchParams.set(TRANSFER_PARAM, payload);
    anchor.href = target.href;
    anchor.referrerPolicy = 'origin';
    // Keep noopener; send only the shop origin needed to verify this handoff.
    anchor.rel = anchor.rel.split(/\s+/).filter(token => token !== 'noreferrer').join(' ');
  };

  const decorateLocalization = form => {
    if (!(form instanceof HTMLFormElement)) return;
    const action = safe(() => new URL(form.action, location.href), null);
    if (!action || action.origin !== location.origin || !/\/localization\/?$/.test(action.pathname)) return;
    const field = form.querySelector('input[name="return_to"]');
    const payload = makeTransfer();
    if (!field || !payload) return;
    const target = safe(() => new URL(field.value || location.pathname, location.origin), null);
    if (!target || target.origin !== location.origin) return;
    target.searchParams.set(TRANSFER_PARAM, payload);
    field.value = target.pathname + target.search + target.hash;
  };

  // The German language picker navigates itself and stops later click listeners.
  // Prepare the final destination explicitly, including the existing age choice.
  window.GTR_prepareShopUrl = href => {
    const target = safe(() => new URL(href, location.href), null);
    if (!target || target.protocol !== 'https:' || !HOSTS.includes(location.hostname) ||
      !HOSTS.includes(target.hostname) || family(target.hostname) === family(location.hostname)) return href;
    const ageUrl = safe(() => window.GTR_prepareAgeUrl?.(target.href), null);
    const url = ageUrl ? new URL(ageUrl) : target;
    const payload = makeTransfer();
    if (payload) url.searchParams.set(TRANSFER_PARAM, payload);
    if (/\/cart\/[0-9][0-9,:]*\/?$/.test(url.pathname)) {
      const age = url.searchParams.get('_gtr_age');
      const consent = url.searchParams.get(TRANSFER_PARAM);
      if (age || consent) {
        const prior = readHandoff(url);
        const handoff = { hash: prior ? prior.hash : url.hash };
        if (age) handoff.age = age;
        if (consent) handoff.consent = consent;
        url.hash = '#_gtr_handoff=' + encodeURIComponent(JSON.stringify(handoff));
      }
    }
    return url.href;
  };

  const updateUi = () => {
    const gate = getGate();
    const privacy = gate?.querySelector('[data-gtr-step="privacy"]');
    if (gate && privacy && manualPreferences && ageVerified()) {
      const age = gate.querySelector('[data-gtr-step="age"]');
      if (age && !age.hidden) age.hidden = true;
      if (privacy.hidden) privacy.hidden = false;
      if (!gate.classList.contains('is-open')) gate.classList.add('is-open');
      if (gate.getAttribute('aria-hidden') !== 'false') gate.setAttribute('aria-hidden', 'false');
      if (!document.documentElement.classList.contains('gtr-agegate-open')) {
        document.documentElement.classList.add('gtr-agegate-open');
      }
      const panel = gate.querySelector('#gtr-consent-settings');
      if (panel && panel.hidden === manualPanel) panel.hidden = !manualPanel;
      const toggle = gate.querySelector('[data-consent-action="settings"]');
      const expanded = manualPanel ? 'true' : 'false';
      if (toggle && toggle.getAttribute('aria-expanded') !== expanded) toggle.setAttribute('aria-expanded', expanded);
      syncInputs(gate, manualDraft);
    }
    const privacyActive = privacy && !privacy.hidden;
    if (gate && gate.classList.contains('gtr-cookie-step-active') !== !!privacyActive) {
      gate.classList.toggle('gtr-cookie-step-active', !!privacyActive);
    }
    if (readRecord() && !manualPreferences) closeCookieUi();
  };

  const refresh = () => {
    if (!initialized) return;
    const known = captureCurrentChoice();
    document.documentElement.classList.toggle('gtr-cookie-consent-known', !!known);
    hideLegacy();
    if (manualPreferences) {
      updateUi();
    } else if (known) {
      closeCookieUi();
    } else if (ageVerified()) {
      choicePrompted = true;
      // Deciding whether to show the prompt does not depend on a slow API,
      // an inconsistent shouldShowBanner response or the current page type.
      showPrivacy(false);
    }
    if (known?.pending) flush();
    else loadApi().then(api => {
      const value = readRecord();
      if (!api || !value || value.pending || acknowledgedId === value.id) return;
      const actual = apiChoice(api);
      if (!actual || CATEGORIES.some(key => actual[key] !== value[key])) {
        // Keep the explicit local decision authoritative and restore that
        // same choice in Shopify; do not ask again or adopt a stale default.
        persist({ ...value, pending: true });
        flush();
      }
    });
  };

  const initialize = () => {
    if (initialized) return;
    importTransfer();
    hideLegacy();
    if (!document.getElementById('gtr-cookie-fix-mobile-style')) {
      const style = document.createElement('style');
      style.id = 'gtr-cookie-fix-mobile-style';
      style.textContent = `
        #gtr-agegate.gtr-cookie-step-active #gtr-agegate-card {
          box-sizing: border-box;
          max-height: calc(100vh - 36px);
          max-height: calc(100dvh - 36px - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px));
          overflow-y: auto;
          overscroll-behavior: contain;
          -webkit-overflow-scrolling: touch;
        }
        @media (max-width: 749px) {
          #gtr-agegate.gtr-cookie-step-active #gtr-agegate-card {
            max-height: calc(100vh - 24px);
            max-height: calc(100dvh - 24px - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px));
          }
          #gtr-agegate.gtr-cookie-step-active .gtr-agegate-btn { min-height: 44px; }
          #gtr-agegate.gtr-cookie-step-active .gtr-consent-switch { width: 44px; height: 44px; }
          #gtr-agegate.gtr-cookie-step-active .gtr-consent-switch > span {
            top: 11px; bottom: 12px; left: 4px; right: 4px;
          }
        }
      `;
      document.head.appendChild(style);
    }
    window.GTR_openCookiePreferences = () => {
      manualPreferences = true;
      manualPanel = true;
      manualDraft = readRecord() || apiChoice(apiNow());
      showPrivacy(true);
      loadApi();
    };
    initialized = true;
    refresh();
    updateUi();
  };

  window.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    if (!target) return;
    const localization = target.closest('form');
    if (localization) decorateLocalization(localization);
    const anchor = target.closest('a[href]');
    if (anchor) decorateLink(anchor);

    const button = target.closest('button, a, [role="button"]');
    if (!button) return;
    const gate = getGate();
    const root = gate?.contains(button) ? gate : button.closest('#gtr-cookie, #gtr-cookie-modal');
    if (!root || button.hasAttribute('data-agegate') || !ageVerified()) return;
    const action = button.getAttribute('data-consent-action');
    const id = button.id;
    const accept = action === 'accept-all' || id === 'gtr-cookie-accept';
    const decline = action === 'required-only' || ['gtr-cookie-decline', 'gtr-cookie-decline2'].includes(id);
    const selection = action === 'save' || id === 'gtr-cookie-save';
    const settings = action === 'settings' || id === 'gtr-cookie-settings';
    if (!accept && !decline && !selection && !settings) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (settings) {
      const panel = gate?.querySelector('#gtr-consent-settings');
      if (!manualPreferences && gate) manualDraft = Object.fromEntries(CATEGORIES.map(key => [key,
        !!gate.querySelector('[data-consent-category="' + key + '"]')?.checked]));
      manualPreferences = true;
      if (panel) {
        panel.hidden = !panel.hidden;
        manualPanel = !panel.hidden;
        button.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
      } else { manualPanel = true; showPrivacy(true); }
      return;
    }
    if (selection) {
      const selected = key => !!(root.querySelector('[data-consent-category="' + key + '"]') ||
        root.querySelector('#gtr-consent-' + key))?.checked;
      save(Object.fromEntries(CATEGORIES.map(key => [key, selected(key)])));
    } else save(Object.fromEntries(CATEGORIES.map(key => [key, accept])));
  }, true);

  window.addEventListener('auxclick', event => {
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    const anchor = target?.closest('a[href]');
    if (anchor) decorateLink(anchor);
  }, true);
  document.addEventListener('change', event => {
    if (!manualPreferences || !(event.target instanceof HTMLInputElement)) return;
    const gate = getGate();
    if (!gate?.contains(event.target) || !event.target.hasAttribute('data-consent-category')) return;
    manualDraft = Object.fromEntries(CATEGORIES.map(key => [key,
      !!gate.querySelector('[data-consent-category="' + key + '"]')?.checked]));
  });
  document.addEventListener('submit', event => decorateLocalization(event.target), true);
  document.addEventListener('gtr:age-verified', () => {
    lastAgeEvent = true;
    refresh();
  });
  document.addEventListener('gtr:age-ready', refresh);
  document.addEventListener('gtr:age-required', () => {
    lastAgeEvent = false;
    manualPreferences = false;
    manualDraft = null;
    hideLegacy();
  });
  document.addEventListener('visitorConsentCollected', () => {
    if (!inFlight.size && !readRecord()?.pending) refresh();
  });
  window.addEventListener('pageshow', refresh);
  window.addEventListener('storage', event => {
    if (event.key !== STORAGE_KEY) return;
    record = null;
    refresh();
  });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();